import { connect } from 'react-redux';
import UserProfileDialog from '../../../../components/navbar/modals/UserProfileDialog';
import { updateUserProfile } from 'core/slices/users';
import { profile } from 'core/selectors';

export default connect(
  (state) => ({
    profile: profile(state),
  }),
  { updateUserProfile }
)(UserProfileDialog);
